// extracted by mini-css-extract-plugin
export default {"box":"styles_box__0Oxl5","content":"styles_content__mjIkB","title":"styles_title__B2EnN","mb10":"styles_mb10__-6cRH","mb30":"styles_mb30__tbFkV","boldTxt":"styles_boldTxt__BDxZn"};